(() => {
  'use strict';

  // Only activate on subscription pages
  if (!document.querySelector('.js-sub-buybox')) return;

  const cfg = window.BlueRhinoConfig || {};

  // ── Token helpers (mirrors bundle.product.js logic) ──────────────────
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, maxAge) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`;
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; path=/; max-age=0`;
  }

  async function requestNewToken() {
    const body = new URLSearchParams();
    body.append('grant_type',    'client_credentials');
    body.append('scope',         'brhd.Create');
    body.append('client_id',     cfg.client_id);
    body.append('client_secret', cfg.client_secret);
    const res = await fetch(`${cfg.tokenBaseURL}/Security/IDS4Server/connect/token`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    });
    const data = await res.json();
    setCookie('access_token', data.access_token, data.expires_in || 3600);
    return data.access_token;
  }

  async function getToken() {
    return getCookie('access_token') || requestNewToken();
  }

  async function fetchProgramAreas(zip) {
    let token = await getToken();
    const headers = new Headers({ Authorization: `Bearer ${token}` });
    let res = await fetch(`${cfg.programIdBaseURL}/BR/HomeDelivery/ProgramAreas?zipcode=${zip}`, { headers });
    if (res.status === 401) {
      deleteCookie('access_token');
      token = await requestNewToken();
      headers.set('Authorization', `Bearer ${token}`);
      res = await fetch(`${cfg.programIdBaseURL}/BR/HomeDelivery/ProgramAreas?zipcode=${zip}`, { headers });
    }
    return res.json();
  }

  function isDeliverable(response) {
    if (!Array.isArray(response) || response.length === 0) {
      return { zip: null, deliverable: 'not-at-all' };
    }
    const prog5 = response.find(p => p.programID == 5 && p.status === 'A');
    if (prog5) return { zip: prog5.zipCode, deliverable: true };
    const non5i = response.find(p => p.programID != 5 && p.status === 'I');
    if (non5i) return { zip: non5i.zipCode, deliverable: 'not-at-all' };
    const allNon5A = response.every(p => p.programID != 5 && p.status === 'A');
    if (allNon5A) return { zip: response[0].zipCode, deliverable: false };
    return { zip: response[0].zipCode, deliverable: 'not-at-all' };
  }

  async function checkZip(zip) {
    const data = await fetchProgramAreas(zip);
    return isDeliverable(data);
  }

  // ── Drawer helpers ────────────────────────────────────────────────────
  const overlay  = document.querySelector('.js-delivery-overlay');
  const drawer   = document.querySelector('.js-delivery-drawer');

  function closeDrawer() {
    // Prefer the shared drawer module so the focus trap listener is removed
    // and focus is returned to the trigger.
    if (window.deliveryDrawer?.closeDeliveryOverlay) {
      window.deliveryDrawer.closeDeliveryOverlay();
      return;
    }

    overlay?.classList.remove('js-open-delivery-overlay');
    drawer?.classList.remove('js-open-delivery-overlay');
    document.body.style.overflow = '';
  }

  function showState(name) {
    // name: 'check' | 'unavailable' | 'confirmed'
    const checkEl     = drawer?.querySelector('.js_product_locate_me_container');
    const unavailEl   = drawer?.querySelector('.js_not_deliverying_container');
    const confirmedEl = drawer?.querySelector('.js_notify_confirmed_container');
    const deliveringEl = drawer?.querySelector('.js_deliverying_container');

    checkEl?.classList.toggle('hidden', name !== 'check');
    unavailEl?.classList.toggle('js-not-deliverying', name === 'unavailable');
    unavailEl?.classList.toggle('hidden', name !== 'unavailable');
    confirmedEl?.classList.toggle('js-notify-confirmed', name === 'confirmed');
    confirmedEl?.classList.toggle('hidden', name !== 'confirmed');
    deliveringEl?.classList.add('hidden');
  }

  function triggerBuyboxDeliverable(zip) {
    const buybox     = document.querySelector('.js-sub-buybox');
    const zipLine    = buybox?.querySelector('.js-deliveringzip');
    const zipTextEl  = buybox?.querySelector('.zip-text');
    if (zipLine) {
      zipLine.classList.remove('hidden');
      zipLine.classList.add('is-delivarable', 'flex');
    }
    if (zipTextEl && zip) zipTextEl.textContent = zip;
    // Also persist zip in URL so spare-tank page inherits it
    const url = new URL(window.location.href);
    url.searchParams.set('z', zip);
    window.history.replaceState({}, '', url);
  }

  // ── Email subscription (Klaviyo) ──────────────────────────────────────
  async function subscribeEmail(email, zip) {
    const listId    = window.BlueRhinoNotifyListId || '';
    const publicKey = window.BlueRhinoKlaviyoKey   || '';

    if (!listId || !publicKey) {
      // No Klaviyo config — still show confirmed state (log warning)
      console.warn('[SubZip] Klaviyo list ID or public key not configured.');
      return true;
    }

    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${publicKey}`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', revision: '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email, properties: { zip_code: zip } },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      }),
    });
    return res.ok || res.status === 202;
  }

  // ── Main interception ─────────────────────────────────────────────────
  function storeLocaterUrl(zip) {
    const base = window.BlueRhinoStoreLocaterUrl || 'https://bluerhino.com/propane-finder';
    return zip ? `${base}${base.includes('?') ? '&' : '?'}z=${encodeURIComponent(zip)}` : base;
  }

  function updateFindStoreLinks(zip) {
    const href = storeLocaterUrl(zip);
    drawer?.querySelectorAll('.js_find_store_link').forEach(a => a.href = href);
  }

  function handleResult({ zip, deliverable }) {
    if (deliverable === true) {
      closeDrawer();
      triggerBuyboxDeliverable(zip);
    } else {
      // Not available (both false and not-at-all → show email capture)
      updateFindStoreLinks(zip);
      showState('unavailable');
      const prefillEl = drawer?.querySelector('.js_not_delivering_zip');
      if (prefillEl && zip) prefillEl.value = zip;
    }
  }

  function bindDrawerEvents() {
    // ── Manual Check button (capture phase so we fire before bundle.product.js) ──
    const checkBtn = drawer?.querySelector('.js_locate_me_manual_cta');
    const zipInput = drawer?.querySelector('.js_locateme_manual_input');
    const spinner  = drawer?.querySelector('.js_locateme_manual_spinner');
    const checkTxt = drawer?.querySelector('.js_locateme_check_text');
    const errEl    = drawer?.querySelector('.js_locateme_manual_error');

    if (zipInput) {
      zipInput.addEventListener('input', () => {
        if (checkBtn) checkBtn.disabled = !zipInput.value.trim();
      });
    }

    checkBtn?.addEventListener('click', async (e) => {
      e.stopImmediatePropagation();
      const zip = zipInput?.value.trim();
      if (!zip || !/^\d{5}$/.test(zip)) {
        errEl?.classList.remove('hidden');
        return;
      }
      errEl?.classList.add('hidden');
      spinner?.classList.remove('hidden');
      if (checkTxt) checkTxt.classList.add('hidden');
      checkBtn.disabled = true;

      try {
        const result = await checkZip(zip);
        handleResult({ ...result, zip: result.zip || zip });
      } catch (err) {
        console.error('[SubZip] ZIP check failed:', err.message);
      } finally {
        spinner?.classList.add('hidden');
        if (checkTxt) checkTxt.classList.remove('hidden');
        checkBtn.disabled = false;
      }
    }, true); // capture: true — fires before bundle.product.js bubble handler

    // ── Locate Me button ──────────────────────────────────────────────
    const locateBtn = drawer?.querySelector('.js_locateme_auto_cta');
    const locateSpinner = drawer?.querySelector('.js-locateme_spinner');
    const locateIcon = drawer?.querySelector('.js_locateme_auto_cta .h-5');

    locateBtn?.addEventListener('click', async (e) => {
      e.stopImmediatePropagation();
      if (!navigator.geolocation) return;

      locateBtn.classList.add('is-locating');
      locateSpinner?.classList.remove('hidden');

      navigator.geolocation.getCurrentPosition(
        async ({ coords }) => {
          try {
            // Reverse-geocode coords to ZIP using a free API
            const geoRes = await fetch(
              `https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json`
            );
            const geo = await geoRes.json();
            const zip = geo?.address?.postcode?.slice(0, 5);
            if (!zip) throw new Error('Could not determine ZIP from location.');
            const result = await checkZip(zip);
            handleResult({ ...result, zip: result.zip || zip });
          } catch (err) {
            console.error('[SubZip] Locate Me failed:', err.message);
          } finally {
            locateBtn.classList.remove('is-locating');
            locateSpinner?.classList.add('hidden');
          }
        },
        (err) => {
          locateBtn.classList.remove('is-locating');
          locateSpinner?.classList.add('hidden');
          console.warn('[SubZip] Geolocation denied:', err.message);
        }
      );
    }, true); // capture: true

    // ── Email input → enable Submit ───────────────────────────────────
    const emailInput  = drawer?.querySelector('.js_notify_input');
    const submitBtn   = drawer?.querySelector('.js_notify_me_cta');
    const submitTxt   = drawer?.querySelector('.js_notify_me_text');
    const submitSpin  = drawer?.querySelector('.js_notify_spinner');

    emailInput?.addEventListener('input', () => {
      if (submitBtn) {
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
        submitBtn.disabled = !valid;
        submitBtn.style.backgroundColor = valid ? '#3f9cd2' : '#cce4f6';
        submitBtn.style.color           = valid ? '#ffffff' : '#3f9cd2';
      }
    });

    submitBtn?.addEventListener('click', async () => {
      const email = emailInput?.value.trim();
      const zip   = drawer?.querySelector('.js_not_delivering_zip')?.value?.trim() || '';
      if (!email) return;

      submitBtn.disabled = true;
      submitTxt?.classList.add('hidden');
      submitSpin?.classList.remove('hidden');

      try {
        await subscribeEmail(email, zip);
      } catch (err) {
        console.error('[SubZip] Email subscribe failed:', err.message);
      } finally {
        submitTxt?.classList.remove('hidden');
        submitSpin?.classList.add('hidden');
      }

      // Show confirmed state briefly, then redirect to find-a-store with ZIP
      const confirmedZipEl = drawer?.querySelector('.js_confirmed_zip');
      if (confirmedZipEl) confirmedZipEl.textContent = zip;
      updateFindStoreLinks(zip);
      showState('confirmed');

      setTimeout(() => {
        window.location.href = storeLocaterUrl(zip);
      }, 2000);
    });
  }

  // ── Reset drawer to check state when reopened ─────────────────────────
  function watchDrawerOpen() {
    if (!overlay) return;
    new MutationObserver(() => {
      if (!overlay.classList.contains('js-open-delivery-overlay')) {
        document.body.style.overflow = '';
        return;
      }
      if (overlay.classList.contains('js-open-delivery-overlay')) {
        showState('check');
        // Clear inputs
        const zipInput   = drawer?.querySelector('.js_locateme_manual_input');
        const emailInput = drawer?.querySelector('.js_notify_input');
        if (zipInput) zipInput.value = '';
        if (emailInput) emailInput.value = '';
        const checkBtn  = drawer?.querySelector('.js_locate_me_manual_cta');
        const submitBtn = drawer?.querySelector('.js_notify_me_cta');
        if (checkBtn)  checkBtn.disabled = true;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.style.backgroundColor = '#cce4f6';
          submitBtn.style.color           = '#3f9cd2';
        }
      }
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }

  async function autoCheckZipFromUrl() {
    const zip = new URL(window.location.href).searchParams.get('z');
    if (!zip || !/^\d{5}$/.test(zip)) return;
    try {
      const result = await checkZip(zip);
      if (result.deliverable === true) {
        triggerBuyboxDeliverable(result.zip || zip);
      }
    } catch (err) {
      console.error('[SubZip] Auto-check from URL failed:', err.message);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindDrawerEvents();
    watchDrawerOpen();
    autoCheckZipFromUrl();
  });
})();
